import { ProviderSet } from "@app/provider-sets";

export const validateProviderSets = (usedProviderSetIds: number[], availableProviderSets: ProviderSet[]): boolean => {
  // -1 is the bulk edit sentinel for a provider set that is mixed across the selected projects
  return usedProviderSetIds
    .filter((p) => !!p && p !== -1)
    .every((providerSetId) =>
      availableProviderSets.map((providerSet) => providerSet.providerSetId).includes(providerSetId),
    );
};
